var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { MediaObject } from "@/media/MediaObject";
import { MediaPeerCore } from "@/media/MediaCore";
import React from "react";
import { MediaEvent } from "@/media/MediaEvent";
import { APPEvent } from "@/events/AppEvents";
import { IncomingCallDialogState } from "@/app/uistore/IncomingDialogState";
export class MediaStore {
    constructor() {
        this.activecall = false;
        this.media = [];
        this.medaiById = new Map();
        this.mymediaactive = false;
        this.windowwidth = window.innerWidth;
        this.activefooterpagenumber = 1;
        this.totalitemperpage = 0;
        this.totalpages = 1;
        this.itemwidth = 210;
        this.error = 'Sorry, failed to start the call. Please try again later.';
        this.showerror = false;
        this.localstream = undefined;
        this.videorefmap = new Map();
        this.sharingscreen = false;
        this.showscreensources = false;
        this.selectedsourceid = "";
        this.centerstagepeer = "";
        this.fullscreen = false;
        this.pinnedpeer = "";
        this.centerstagevideoref = React.createRef();
        this.open = false;
        this.showhiddenbox = false;
        this.showdevicepicker = false;
        this.devices = [];
        this.hasDevice = false;
        this.sharingpeerid = new Set();
        this.peerhasnovideo = false;
        this.switchmode = false;
        this.toggleCamera = false;
        this.incomingcalldialogstate = new IncomingCallDialogState();
        this.mobileMediaById = new Map();
        this.incomingcall = false;
        makeObservable(this);
        window.onresize = () => {
            this.updateWindowWidth();
        };
        this.updateWindowWidth();
        APPEvent.addSubscriberForShowMedia((req) => {
            this.setActiveCall(true);
            this.init();
        });
        MediaEvent.addSubcriberForMediaObject((ob) => {
            this.setMediaObject(ob);
        });
        MediaEvent.addSubcriberForPeerDisconnected((peerid) => {
            this.removePeer(peerid);
        });
        MediaEvent.addSubcriberForAudioMuteUnmute((ad) => {
            const peer = this.medaiById.get(ad.peerid);
            if (peer) {
                if (ad.mute) {
                    peer.setHasAudio(false);
                }
                else {
                    peer.setHasAudio(true);
                }
            }
        });
        MediaEvent.addSubcriberForSharingScreen((sh) => {
            const mobj = this.getPeerMediaObject(sh.peerid);
            if (mobj !== undefined) {
                if (sh.sharing) {
                    mobj.setMediacssclass("");
                    if (!this.pinnedpeer) {
                        this.pinPeer(sh.peerid);
                    }
                    this.setSharingpeerid(sh.peerid);
                }
                else {
                    mobj.setMediacssclass("facingcameravideo");
                    if (sh.peerid === this.pinnedpeer) {
                        this.pinPeer("");
                    }
                    this.removeSharingpeerid(sh.peerid);
                }
            }
        });
        MediaEvent.addSubcriberForSpeaking((spek) => {
            if (this.sharingscreen || this.pinnedpeer) {
                return;
            }
            const mobj = this.getPeerMediaObject(spek);
            if (mobj !== undefined && this.centerstagepeer !== spek) {
                this.presentPeer(spek);
            }
        });
        MediaEvent.addSubcriberForSharingStopped(() => {
            this.stopSharing();
        });
        APPEvent.addSubscriberForShowMedia((req) => {
            this.setActiveCall(true);
            this.init();
        });
        MediaEvent.addSubscriberForVideoFacingCamera((peerid) => {
            var _a;
            (_a = this.medaiById.get(peerid)) === null || _a === void 0 ? void 0 : _a.setMediacssclass("facingcameravideo");
        });
        MediaEvent.addSubscriberForVideoEnvCamera((peerid) => {
            var _a;
            (_a = this.medaiById.get(peerid)) === null || _a === void 0 ? void 0 : _a.setMediacssclass("");
        });
        APPEvent.addSubscriberForMediaShut(() => {
            this.reset();
        });
    }
    fullScreenFocued() {
        const elem = document.getElementById("mainscreen");
        if (elem) {
            elem.requestFullscreen();
        }
    }
    setIncoming(inc) {
        this.incomingcall = inc;
    }
    setShowHiddenBox(show) {
        this.showhiddenbox = show;
    }
    setSwitchMode(mode) {
        this.switchmode = mode;
    }
    setToggleCamera(toggle) {
        this.toggleCamera = toggle;
    }
    setActiveCall(init) {
        this.activecall = init;
    }
    setError(error) {
        this.error = error;
    }
    setSharingpeerid(peerid) {
        this.sharingpeerid.add(peerid);
    }
    removeSharingpeerid(peerid) {
        this.sharingpeerid.delete(peerid);
    }
    setAudioDevice(device) {
        this.audiodevice = device;
        this.hasDevice = true;
    }
    setVideoDevice(device) {
        this.videodevice = device;
    }
    setDevicePicker(show) {
        this.showdevicepicker = show;
    }
    setDevices(devices) {
        this.devices.splice(0, this.devices.length);
        for (const device of devices) {
            this.devices.push(device);
        }
    }
    async switchSelectedDevice() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this.audiodevice === undefined) {
            return;
        }
        this.setDevicePicker(false);
        if ((_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.hasvideo) {
            (_c = (_b = this.mymedia) === null || _b === void 0 ? void 0 : _b.mediastream) === null || _c === void 0 ? void 0 : _c.getTracks().forEach((tr) => tr.stop());
        }
        (_e = (_d = this.mymedia) === null || _d === void 0 ? void 0 : _d.mediastream) === null || _e === void 0 ? void 0 : _e.getTracks().forEach((tr) => tr.enabled = false);
        // const stream = await MediaPeerCore.createStream(this.audiodevice, this.videodevice);
        // if (stream === undefined) {
        //     this.setError("Sorry, failed to start video meeting. Maybe you need to give LetrWing audio/video permission. You can change this via your system settings."
        //         + " Or you might have joined another ongoing meeting on your system.");
        //     this.setShowError(true);
        //     return;
        const stream = await MediaPeerCore.shareSwitchedMedia(this.audiodevice, this.videodevice);
        if (stream !== undefined && this.mymedia !== undefined) {
            this.mymedia.mediastream = new MediaStream();
            if (stream.getVideoTracks().length > 0) {
                stream.getVideoTracks().forEach((tr) => {
                    var _a, _b;
                    (_b = (_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.mediastream) === null || _b === void 0 ? void 0 : _b.addTrack(tr);
                });
            }
            if (stream.getAudioTracks().length > 0) {
                stream.getAudioTracks().forEach((tr) => {
                    var _a, _b;
                    (_b = (_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.mediastream) === null || _b === void 0 ? void 0 : _b.addTrack(tr);
                });
            }
            (_f = this.mymedia) === null || _f === void 0 ? void 0 : _f.setHasVideo(true);
            (_h = (_g = this.mymedia) === null || _g === void 0 ? void 0 : _g.mediastream) === null || _h === void 0 ? void 0 : _h.getTracks().forEach((tr) => tr.enabled = true);
            if (this.mymedia.videoref.current !== null) {
                try {
                    this.mymedia.videoref.current.pause();
                    this.mymedia.videoref.current.srcObject = null;
                    this.mymedia.videoref.current.srcObject = this.mymedia.mediastream;
                    await this.mymedia.videoref.current.play();
                }
                catch (ex) {
                    console.log(ex);
                }
            }
        }
    }
    async switchCamera() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if ((_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.hasvideo) {
            (_c = (_b = this.mymedia) === null || _b === void 0 ? void 0 : _b.mediastream) === null || _c === void 0 ? void 0 : _c.getVideoTracks().forEach((tr) => tr.stop());
        }
        const stream = await MediaPeerCore.switchMediaDevices(this.toggleCamera);
        if (stream === undefined && this.mymedia !== undefined && this.mymedia.mediastream !== undefined) {
            const mediastream = new MediaStream();
            // this.mymedia.mediastream = new MediaStream();
            const prevstrack = (_d = MediaPeerCore.getMyLocalStream()) === null || _d === void 0 ? void 0 : _d.getVideoTracks()[0];
            if (this.mymedia.mediastream.getVideoTracks().length > 0) {
                mediastream.addTrack(this.mymedia.mediastream.getVideoTracks()[0]);
            }
            this.mymedia.mediastream = mediastream;
            (_f = (_e = this.mymedia) === null || _e === void 0 ? void 0 : _e.mediastream) === null || _f === void 0 ? void 0 : _f.getVideoTracks().forEach((tr) => tr.enabled = true);
            if (((_g = this.mymedia) === null || _g === void 0 ? void 0 : _g.videoref.current) !== null) {
                try {
                    await ((_h = this.mymedia) === null || _h === void 0 ? void 0 : _h.videoref.current.play());
                }
                catch (ex) {
                }
            }
            alert("Sorry camera couldn't be switched.");
        }
        if (stream !== undefined && this.mymedia !== undefined) {
            this.mymedia.mediastream = new MediaStream();
            if (stream.getVideoTracks().length > 0) {
                this.mymedia.mediastream.addTrack(stream.getVideoTracks()[0]);
            }
            (_j = this.mymedia) === null || _j === void 0 ? void 0 : _j.setHasVideo(true);
            (_l = (_k = this.mymedia) === null || _k === void 0 ? void 0 : _k.mediastream) === null || _l === void 0 ? void 0 : _l.getVideoTracks().forEach((tr) => tr.enabled = true);
            if (this.mymedia.videoref.current !== null) {
                this.mymedia.videoref.current.pause();
                this.mymedia.videoref.current.srcObject = this.mymedia.mediastream;
                try {
                    await this.mymedia.videoref.current.play();
                }
                catch (ex) {
                    console.log(ex);
                    alert(ex);
                }
                // MediaPeerCore.shareSwitchedMedia(stream);
            }
            this.setSharingpeerid(MediaPeerCore.mylocalid);
        }
    }
    async getDevices() {
        const devices = await MediaPeerCore.getMediaDevices();
        if (devices && devices.length > 0) {
            this.setDevices(devices);
            this.setDevicePicker(true);
        }
        else {
            this.setError("Seems, like either there is no camera/microphone on this system or Letrwing doesn't have permission to access it. Please check media permissions on your system and try again.");
            this.setShowError(true);
            this.setOpen(true);
            this.setDevicePicker(false);
            return;
        }
    }
    async init() {
        this.setSwitchMode(false);
        this.getDevices();
    }
    async pickedinit() {
        if (this.audiodevice === undefined) {
            return;
        }
        this.setDevicePicker(false);
        this.setOpen(true);
        const mystream = await MediaPeerCore.createStream(this.audiodevice, this.videodevice);
        if (mystream === undefined) {
            this.setError("Sorry, failed to start video meeting. Maybe you need to give LetrWing audio/video permission. You can change this via your system settings."
                + " Or you might have joined another ongoing meeting on your system.");
            this.setShowError(true);
            return;
        }
        const myobj = new MediaObject(MediaPeerCore.mylocalid, true);
        myobj.setHasAudio(true);
        if (mystream.getVideoTracks().length > 0) {
            myobj.setHasVideo(true);
        }
        myobj.setAddingPeer(false);
        myobj.mediastream = new MediaStream();
        mystream.getVideoTracks().forEach((tr) => { var _a; return (_a = myobj.mediastream) === null || _a === void 0 ? void 0 : _a.addTrack(tr); });
        this.setMyMedia(myobj);
        this.setMediaObject(myobj);
        MediaPeerCore.startMyCall(this.incomingcall);
    }
    getPeerMediaObject(peerid) {
        const mobj = this.medaiById.get(peerid);
        return mobj;
    }
    unpinPeer() {
        this.pinnedpeer = "";
    }
    pinPeer(peerid) {
        this.pinnedpeer = peerid;
        this.presentPeer(peerid);
    }
    setOpen(open) {
        this.open = open;
    }
    setPeerHasNoVideo(vid) {
        this.peerhasnovideo = vid;
    }
    async presentPeer(peerid) {
        this.setCenterStagePeerid(peerid);
        setTimeout(async () => {
            try {
                if (this.centerstagevideoref !== undefined &&
                    this.centerstagevideoref.current !== null) {
                    const mobj = this.getPeerMediaObject(peerid);
                    if (mobj !== undefined && mobj.mediastream !== undefined) {
                        this.centerstagevideoref.current.srcObject = mobj.mediastream;
                        if (mobj.mediastream.getVideoTracks().length > 0 ||
                            this.sharingpeerid.has(peerid)) {
                            await this.centerstagevideoref.current.play();
                            this.setPeerHasNoVideo(false);
                        }
                        else {
                            this.setPeerHasNoVideo(true);
                        }
                    }
                }
            }
            catch (Ex) { }
        }, 10);
    }
    async shareScreen() {
        var _a;
        const sscreen = await MediaPeerCore.sharescreen();
        if (sscreen !== undefined && this.mymedia !== undefined) {
            (_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.setMediacssclass("");
            this.mymedia.mediastream = new MediaStream();
            if (sscreen.getVideoTracks().length > 0) {
                this.mymedia.mediastream.addTrack(sscreen.getVideoTracks()[0]);
            }
            if (this.mymedia.videoref.current !== null) {
                this.mymedia.videoref.current.pause();
                this.mymedia.videoref.current.srcObject = this.mymedia.mediastream;
                try {
                    await this.mymedia.videoref.current.play();
                }
                catch (ex) {
                    console.log(ex);
                }
            }
            if (this.centerstagepeer === MediaPeerCore.mylocalid) {
                if (this.centerstagevideoref !== null && this.centerstagevideoref.current !== null) {
                    this.centerstagevideoref.current.srcObject = this.mymedia.mediastream;
                    try {
                        await this.centerstagevideoref.current.play();
                    }
                    catch (ex) {
                        console.log(ex);
                    }
                }
            }
            this.setSharingpeerid(MediaPeerCore.mylocalid);
        }
        this.setSharingScreen(true);
    }
    setCenterStagePeerid(id) {
        this.centerstagepeer = id;
    }
    async stopSharing() {
        var _a;
        if (!this.sharingscreen) {
            return;
        }
        const sscreen = await MediaPeerCore.stopScreenShare();
        (_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.setMediacssclass("facingcameravideo");
        if (sscreen !== undefined && this.mymedia !== undefined) {
            this.mymedia.mediastream = new MediaStream();
            if (sscreen.getVideoTracks().length > 0) {
                this.mymedia.mediastream.addTrack(sscreen.getVideoTracks()[0]);
            }
            if (this.mymedia.videoref.current !== null) {
                this.mymedia.videoref.current.pause();
                this.mymedia.videoref.current.srcObject = this.mymedia.mediastream;
                try {
                    if (this.mymedia.mediastream.getVideoTracks().length > 0) {
                        await this.mymedia.videoref.current.play();
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
            }
            if (this.centerstagepeer === MediaPeerCore.mylocalid) {
                if (this.centerstagevideoref !== null && this.centerstagevideoref.current !== null) {
                    this.centerstagevideoref.current.pause();
                    this.centerstagevideoref.current.srcObject = this.mymedia.mediastream;
                    try {
                        if (this.mymedia.mediastream.getVideoTracks().length > 0) {
                            // only play if there is video ?
                            await this.centerstagevideoref.current.play();
                        }
                    }
                    catch (ex) {
                        console.log(ex);
                    }
                }
            }
        }
        this.setSharingScreen(false);
        this.removeSharingpeerid(MediaPeerCore.mylocalid);
    }
    async toogleScreenShare() {
        if (this.sharingscreen) {
            this.stopSharing();
        }
        else {
            this.shareScreen();
        }
    }
    setSharingScreen(sh) {
        this.sharingscreen = sh;
    }
    toggleMyAudio() {
        var _a, _b, _c;
        if ((_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.hasaudio) {
            (_b = this.mymedia) === null || _b === void 0 ? void 0 : _b.setHasAudio(false);
            // do it in core stream as well
            MediaPeerCore.muteMyAudio();
        }
        else {
            (_c = this.mymedia) === null || _c === void 0 ? void 0 : _c.setHasAudio(true);
            MediaPeerCore.unmuteMyAudio();
            // do it in core stream as well
        }
    }
    removePeer(peerid) {
        const eobj = this.medaiById.get(peerid);
        this.medaiById.delete(peerid);
        if (eobj != undefined) {
            const index = this.media.indexOf(eobj);
            if (index > -1) {
                this.media.splice(index, 1);
            }
            this.calculateTotalPages();
            this.calculateTotalItemPerPage();
        }
        if (this.centerstagepeer === peerid) {
            this.setCenterStagePeerid("");
        }
    }
    async toggleMyVideo() {
        var _a, _b, _c, _d, _e, _f;
        if ((_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.hasvideo) {
            (_b = this.mymedia) === null || _b === void 0 ? void 0 : _b.setHasVideo(false);
            MediaPeerCore.muteMyVideo();
        }
        else {
            (_c = this.mymedia) === null || _c === void 0 ? void 0 : _c.setHasVideo(true);
            MediaPeerCore.unmuteMyVideo();
            try {
                await ((_f = (_e = (_d = this.mymedia) === null || _d === void 0 ? void 0 : _d.videoref) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.play());
            }
            catch (ex) { }
        }
    }
    async disconnect() {
        var _a, _b;
        // we need to sto our stream
        (_b = (_a = this.mymedia) === null || _a === void 0 ? void 0 : _a.mediastream) === null || _b === void 0 ? void 0 : _b.getTracks().forEach((tr) => tr.stop());
        this.reset();
        await MediaPeerCore.disConnect();
    }
    reset() {
        this.medaiById.clear();
        this.media = [];
        this.mymedia = undefined;
        this.mymediaactive = false;
        this.setActiveCall(false);
        this.setOpen(false);
    }
    setMyMedia(mobj) {
        this.mymedia = mobj;
        this.mymediaactive = true;
    }
    /**
     *
     * @param st Strema added
     */
    setMediaStream(st) {
        this.localstream = st;
    }
    setShowError(err) {
        this.showerror = err;
    }
    async setMediaObject(md) {
        const eobj = this.medaiById.get(md.id);
        if (eobj !== undefined) {
            eobj.setAddingPeer(md.addingpeer);
            eobj.setHasAudio(md.hasaudio);
            eobj.setHasVideo(md.hasvideo);
            if (md.username) {
                eobj.setUserName(md.username);
            }
            // what about stream 
            if (md.mediastream) {
                if (eobj.videoref.current !== null) {
                    eobj.videoref.current.srcObject = md.mediastream;
                    try {
                        await eobj.videoref.current.play();
                    }
                    catch (Ex) {
                    }
                }
                eobj.setMediaStream(md.mediastream);
            }
        }
        else {
            this.videorefmap.set(md.id, React.createRef());
            this.media.push(md);
            this.medaiById.set(md.id, md);
            this.calculateTotalPages();
            this.calculateTotalItemPerPage();
        }
    }
    removeMediaObject(id) {
        const md = this.medaiById.get(id);
        if (md !== undefined) {
            const index = this.media.indexOf(md);
            if (index > -1) {
                this.media.splice(index, 1);
            }
        }
    }
    setTotalItemPerPage(items) {
        this.totalitemperpage = items;
    }
    updateWindowWidth() {
        this.windowwidth = window.innerWidth;
        this.calculateTotalPages();
        this.calculateTotalItemPerPage();
    }
    moveBackward() {
        if (this.activefooterpagenumber > 1) {
            this.activefooterpagenumber -= 1;
        }
    }
    moveForward() {
        if (this.activefooterpagenumber < this.totalpages) {
            this.activefooterpagenumber += 1;
        }
    }
    getPageItems(pageNumber) {
        const startindex = (pageNumber - 1) * this.totalitemperpage;
        let endindex = startindex + this.totalitemperpage;
        if (endindex > this.media.length) {
            endindex = this.media.length;
        }
        return this.media.slice(startindex, endindex);
    }
    calculateTotalPages() {
        const totalwidthreq = this.media.length * 200;
        let pages = Math.ceil(totalwidthreq / this.windowwidth);
        if (pages == 0) {
            pages = 1;
        }
        this.totalpages = pages;
    }
    calculateTotalItemPerPage() {
        this.totalitemperpage = Math.floor((this.windowwidth - 60) / this.itemwidth);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "activecall", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], MediaStore.prototype, "media", void 0);
__decorate([
    observable,
    __metadata("design:type", MediaObject)
], MediaStore.prototype, "activemedia", void 0);
__decorate([
    observable,
    __metadata("design:type", MediaObject)
], MediaStore.prototype, "mymedia", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "mymediaactive", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "windowwidth", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "activefooterpagenumber", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "totalitemperpage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "totalpages", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "error", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "showerror", void 0);
__decorate([
    observable,
    __metadata("design:type", MediaStream)
], MediaStore.prototype, "localstream", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "sharingscreen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "showscreensources", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "selectedsourceid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "centerstagepeer", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "fullscreen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "pinnedpeer", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "centerstagevideoref", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "showhiddenbox", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "showdevicepicker", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], MediaStore.prototype, "devices", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "hasDevice", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], MediaStore.prototype, "sharingpeerid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "peerhasnovideo", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "switchmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "toggleCamera", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MediaStore.prototype, "incomingcall", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setIncoming", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setShowHiddenBox", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setSwitchMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setToggleCamera", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setActiveCall", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setSharingpeerid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "removeSharingpeerid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setAudioDevice", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setVideoDevice", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setDevicePicker", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setDevices", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "unpinPeer", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "pinPeer", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setPeerHasNoVideo", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", Promise)
], MediaStore.prototype, "presentPeer", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MediaStore.prototype, "shareScreen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setCenterStagePeerid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MediaStore.prototype, "stopSharing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setSharingScreen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "toggleMyAudio", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "removePeer", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MediaStore.prototype, "toggleMyVideo", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], MediaStore.prototype, "disconnect", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MediaObject]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setMyMedia", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MediaStream]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setMediaStream", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setShowError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MediaObject]),
    __metadata("design:returntype", Promise)
], MediaStore.prototype, "setMediaObject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "removeMediaObject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "setTotalItemPerPage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "updateWindowWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "moveBackward", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "moveForward", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "calculateTotalPages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MediaStore.prototype, "calculateTotalItemPerPage", null);
